import {
    Box,
    Card,
    useMediaQuery,
    useTheme
} from '@mui/material'
import React, { Dispatch } from 'react'
import Content from './all.content';
import { useFormikContext } from 'formik';
import { INITIAL_FORM_STATE_TYPE } from '../dataCompletion';
import dayjs from 'dayjs';
import * as applicationService from "services/application-service";
import { useNavigate, useParams } from 'react-router-dom';
import { convertFormikToApplication, convertFormikToApplicationWithDetails } from 'utilities/formik-values-converter';

interface Props {
    application: ApplicationWithDetails,
    titlePath: string,
    form: any,
    submitDisabled?: boolean,
    error: string;
    isRenew: boolean;
}

export default function AllSteps(props: Props) {
    const theme = useTheme();
    const navigate = useNavigate();
    const { values } = useFormikContext<INITIAL_FORM_STATE_TYPE>();
    const isMobile = useMediaQuery(theme.breakpoints.between("xs", "lg"));
    const { application, titlePath, form, submitDisabled, isRenew } = props
    const { applicationId, completionHash } = useParams();

    //TODO: move the sx props to custom style file and custom property const
    return (
        <div>
            {isMobile ? (
                <Content
                    form={form}
                    titlePath={titlePath}
                    submitDisabled={submitDisabled}
                    error={props.error}
                    isRenew={isRenew}
                />
            ) : (
                <Card sx={{
                    px: "4rem",
                    py: "20px",
                    borderRadius: "30px",
                    width: { xs: "200px", md: "500px", lg: "600px" },
                }}>
                    <Content
                        form={form}
                        titlePath={titlePath}
                        submitDisabled={submitDisabled}
                        error={props.error}
                        isRenew={isRenew}
                    />
                </Card>
            )}
        </div>
    )
}